// The refresh-token counterpart of was-sent-with-stale-access-token.js. A refresh carries no Authorization
// header, only the refresh token in its body, so the access-token check can never call its 401 stale. When a
// rotation (2FA confirm, password change) replaced the refresh token while the refresh was on the wire, the
// server rejects the OLD token - an answer about a token the app no longer holds, not the end of the session.
const readSentRefreshToken = (requestData) => {
  if (!requestData) {
    return undefined
  }

  if (typeof requestData === 'string') {
    try {
      return JSON.parse(requestData).token
    } catch {
      return undefined
    }
  }

  return requestData.token
}

export default ({
  requestConfig,
  refreshToken,
}) => {
  if (!requestConfig?.url?.includes('refresh-token')) {
    return false
  }

  const sentRefreshToken = readSentRefreshToken(requestConfig.data)

  // Nothing to tell apart: leave the 401 to the normal logout path
  if (!sentRefreshToken || !refreshToken) {
    return false
  }

  return sentRefreshToken !== refreshToken
}
